var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", { staticClass: "md-table-row" }, [
    _c("td", { staticClass: "md-table-cell md-table-measures" }, [
      !_vm.isEditing
        ? _c("div", { staticClass: "md-table-cell-container wizard-data" }, [
            _vm._v(_vm._s(_vm.label))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isEditing && _vm.inputType != "textarea"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.changed,
                expression: "changed"
              }
            ],
            ref: "inputValue",
            staticClass: "md-table-cell-container m-left-10 wizard-data",
            attrs: { type: "text", placeholder: "Value" },
            domProps: { value: _vm.changed },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.changed = $event.target.value
                },
                _vm.sanitizeChanged
              ]
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isEditing && _vm.inputType == "textarea"
        ? _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.changed,
                expression: "changed"
              }
            ],
            ref: "inputValue",
            staticClass:
              "form-control input-value pt-input input-focus m-left-10 mt-10 mb-10",
            attrs: { placeholder: "Value..." },
            domProps: { value: _vm.changed },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.changed = $event.target.value
                },
                _vm.sanitizeChanged
              ]
            }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("td", { staticClass: "md-table-cell md-table-measures" }, [
      _c(
        "div",
        { staticClass: "md-table-cell-container wizard-buttons m-left-5" },
        [
          _vm.isEditing
            ? [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.update()
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fas fa-save small-icon picker-icon",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(" "),
                    _c("md-tooltip", { attrs: { "md-direction": "left" } }, [
                      _vm._v("Save")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "m-left-10",
                    on: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fas fa-times picker-icon-danger",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(" "),
                    _c("md-tooltip", { attrs: { "md-direction": "right" } }, [
                      _vm._v("Cancel")
                    ])
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          !_vm.isEditing
            ? [
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.edit()
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-edit small-icon",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(" "),
                    _c("md-tooltip", { attrs: { "md-direction": "left" } }, [
                      _vm._v("Edit")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "m-left-5",
                    on: {
                      click: function($event) {
                        return _vm.remove()
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-trash small-icon picker-icon-danger",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(" "),
                    _c("md-tooltip", { attrs: { "md-direction": "right" } }, [
                      _vm._v("Remove")
                    ])
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ebd80ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ebd80ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfigurationEditRow.vue
// module id = null
// module chunks = 